import env from './env';

export default (url?: string | null) =>
  url && url[0] === '/'
    ? `${env('API_URL').replace('/api/{slug}', '')}${url}`
    : url || '';
